import PumpAttendant from '../../models/configs/pumpAttendants.model'

let storeContent = utils.generateStore({
   PumpAttendant,
   attendants: [],
   selectedAttendant: {},
   showUpload: false,
   showEdit: false,
})

export default {
   state: {
      ...storeContent.state
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addAttendant(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               await api.fetchEndpointSecure({
                  resource: "registration",
                  action: "add:attendant",
                  data: {
                     idNumber: data.idNumber,
                     firstName: data.firstName,
                     lastName: data.lastName,
                     dealerName: data.dealerNames,
                     mobileNumber: data.mobileNumber.code.callingCode + '' + data.mobileNumber.mobile,
                     station: data.station._id,
                  },
                  meta_data: {}
               })

               await ctx.dispatch('fetchAttendants')
               $notify('success', 'Attendant Created', `Attendant ${data.firstName} ${data.lastName} successfully created.`)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async editPumpAttendant(ctx,payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'registration',
                  action: 'edit:attendant',
                  data: {
                     id: ctx.getters.selectedAttendant._id,
                     idNumber: data.idNumber,
                     csaName: data.csaName,
                     dealerName: data.dealerName,
                     station: data.station._id,
                  },
                  meta_data: {}
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchAttendants')
               ctx.commit('showEdit', false)
               $notify('success', 'Pump Attendant Updated', `Pump Attendant ${data.csaName} successfully updated.`,5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deletePumpAttendant(ctx,id) {
         try {
            EventBus.$emit('loader:show', true)

            let res = await api.fetchEndpointSecure({
               resource: "registration",
               action: "delete:attendant",
               data: {
                  id
               },
               meta_data: {}
            })

            await ctx.dispatch('fetchAttendants')
            $notify('success', 'Pump Attendant Deleted', `Pump Attendant ${res.result.attendant.csaName} successfully deleted.`)
            EventBus.$emit('loader:show', false)
         } catch (err) {
            EventBus.$emit('loader:show', false)
            throw err
         }
      },
      async uploadPumpAttendants(ctx,payload){
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               let bodyFormData = new FormData()
               bodyFormData.append('csv',data.attendants[0]);
               bodyFormData.append('resource','registration');
               bodyFormData.append('action','add:multiple_attendants');
               bodyFormData.append('file_action','excel');

               ctx.commit('showUpload',false)
               let res = await api.upload(api.parseRoute('/upload'),bodyFormData,'pump_attendants');
               await ctx.dispatch('fetchAttendants')
               $notify('success', 'Uploaded Pump Attendants', res.result.msg,10)
            }
            ctx.commit('loading', false)
         }catch(err){
            ctx.commit('loading', false)
            $notify('error', 'Upload Fail', `Upload for ${'pump_attendants'} failed. Please Try again Later.`,15)
            throw err;
         }
      },
      async fetchAttendants(ctx) {
         try {
            ctx.commit('show', false)
            let res = await api.fetchEndpointSecure({
               resource: "registration",
               action: "get:attendants",
               data: {},
               meta_data: {}
            })
            ctx.commit('attendants', res.result.attendants)

            EventBus.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            // Fetch User Groups
            let res = await api.fetchEndpointSecure({
               resource: "registration",
               action: "get:stations",
               data: {},
               meta_data: {}
            })
            let form = utils.appendSelectData({
               form: PumpAttendant.forms.add_pump_attendant,
               model: 'station',
               label: 'name',
               data: res.result.stations
            })

            form = utils.appendSelectData({
               form: PumpAttendant.forms.edit_pump_attendant,
               model: 'station',
               label: 'name',
               data: res.result.stations
            })

            if (form) {
               let Model = ctx.getters.PumpAttendant
               Model.forms.add_pump_attendant = form
               ctx.commit('PumpAttendant', Model)
            }
         } catch (err) {
            throw err
         }
      }
   }
};